import { t } from "ttag";

import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { CATEGORY_SLUG } from "@/shared/domains";

export const IS_CALL_CENTER_PARAM_KEY = "is_call_center";

export const DEFAULT_PRICE_VARIANT = "0";

export const SIGNUP_FUNNEL = {
  ORIGINAL_ONBOARDING: "original_onboarding",
  INTAKE_ONBOARDING: "intake_onboarding",
  LONGEVITY: "longevity",
} as const;

export const getCategoryName = (slug: CategoryWithSelectedProduct["slug"]) => {
  return {
    [CATEGORY_SLUG.WEIGHT_LOSS]: t`GLP-1 Weight loss`,
    [CATEGORY_SLUG.HAIR_GROWTH]: t`Hair growth`,
    [CATEGORY_SLUG.MICRODOSING]: t`GLP-1 Microdosing`,
    [CATEGORY_SLUG.LONGEVITY]: t`Longevity`,
    [CATEGORY_SLUG.TESTOSTERONE]: t`Testosterone`,
  }[slug];
};
